<section [ngClass]="dynamicClass">
  <div class="eq-container-left" [ngClass]="isMobile ? 'eq-banner-logo-array-background' : ' ' ">
    <div class="eq-pt-[44px] lg:eq-pt-[60px] eq-pb-[44px] lg:eq-pb-[60px] lg:eq-pr-[130px] lg:eq-pl-[122px] eq-banner-logo-array-background">
      <div class="eq-text-heading2-m lg:eq-text-heading2 eq-text-blue-darkBlue eq-font-bold" [ngClass]="rendering?.fields?.Subtitle ? 'eq-mb-[18px] lg:eq-mb-[24px]' : 'eq-mb-[32px] lg:eq-mb-[60px]' " *scText="rendering?.fields?.Title"></div>
      <ng-container *ngIf="rendering?.fields?.Subtitle">
        <div class="eq-mb-[32px] lg:eq-mb-[60px] eq-text-body-m lg:eq-text-body eq-text-black-natural-60" *scText="rendering?.fields?.Subtitle"></div>
      </ng-container>
      <div *ngIf="!isMobile" class="eq-grid eq-grid-cols-5 eq-gap-[20px]">
        <ng-container *ngFor="let logo of rendering?.fields?.LogosArray">
          <img class="eq-h-[110px]" *scImage="logo.fields?.Image">
        </ng-container>
      </div>
      <div #BannerLogoArraySlider *ngIf="isMobile" class="swiper">
        <div class="swiper-wrapper">
          <ng-container *ngFor="let logo of rendering?.fields?.LogosArray">
            <div class="swiper-slide !eq-w-fit">
              <img class="eq-h-[140px] eq-w-[130px] eq-object-cover" *scImage="logo.fields?.Image">
            </div>
          </ng-container>
        </div>
      </div>
      <a *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-secondary eq-w-full lg:eq-w-fit eq-mt-6 lg:eq-mt-[60px]" hybridHref href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
    </div>
  </div>
</section>
